export async function First<T>(iterable: AsyncGenerator<T>): Promise<T> {
  const { value, done }: IteratorResult<T> = await iterable.next()

  if (done) throw new Error("No elements in iterable")

  return value
}
// No default export, only named exports
